import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "../middleware/interceptor";

export const generateCourse = createAsyncThunk(
    "course/generate",
    async (userId:any) => {
      try {
        const response = await server.post(`/course/generate?user_id=${userId}`, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );

  export const getTaskStatus = createAsyncThunk(
    "course/status",
    async (taskId:any) => {
      try {
        const response = await server.get(`/course/task-status/${taskId}`, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );

    export const getCourseList = createAsyncThunk(
    "course/list",
    async (userId:any) => {
      try {
        const response = await server.get(`/course/list?user_id=${userId}`, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );

  export const generateIntermediateCourse = createAsyncThunk(
    "course/generate/intermediate",
    async (userId:any) => {
      try {
        const response = await server.post(`/course/generate-intermediate?user_id=${userId}`, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );

  export const generateAdvancedCourse = createAsyncThunk(
    "course/generate/advanced",
    async (userId:any) => {
      try {
        const response = await server.post(`/course/generate-advanced?user_id=${userId}`, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );

  export const submitLessonTest = createAsyncThunk(
    "course/submit/lessonTest",
    async (requestBody:any) => {
      try {
        const response = await server.post(`/course/submit-mcq`,requestBody, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );

  export const getLessonStatus = createAsyncThunk(
    "course/getLessonStatus",
    async (requestBody:any) => {
      try {
        const response = await server.post(`/course/lesson_status`,requestBody, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );

  export const startCourse = createAsyncThunk(
    "course/startCourse",
    async (taskId: any) => {
      try {
        const response = await server.post(`/course/start-course/${taskId}`, {}, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return (error.response.data || "Something went wrong")
      }
    }
  );